<div class="input-date">
    <label class="col-form-label" v-if="label" :for="id" ref="labelForm">{{ label }} <span v-if="required">(*)</span></label>
    <input class="form-control" :class="{ 'is-error': isError }" v-model="value" type="date" :id="id" :disabled="disabled" :min="min" @blur="onBlur" :placeholder="placeholder"/>
    <div class="error-text" v-if="errorText" :style="{left: distanceWithLabel}">{{errorText}}</div>
</div>
